export default __webpack_public_path__ + "static/camptoo-aef6b4fe8bd6473f72f51e863017cd7a.png";